"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MMMConfigurationDatabase = void 0;
const dexie_1 = __importDefault(require("dexie"));
class MMMConfigurationDatabase extends dexie_1.default {
    constructor(logger, application) {
        super("MMConfigurationDatabase");
        this.logger = logger;
        this.logger.log("Configuring the database...");
        this.version(application.MajorVersion).stores({
            configuration: "++Id, &Name, Value",
            song: "++songId, name, listImageUrl, bannerImageUrl, dateReleased, audioStreamUrl, additionalMetadata",
            resource: "++resourceId, resourceName, resourceType, resourceBody"
        });
    }
}
exports.MMMConfigurationDatabase = MMMConfigurationDatabase;
//# sourceMappingURL=MMMConfigurationDatabase.js.map